import { useInstallPrompt } from "../hooks/useInstallPrompt";
import "./InstallBanner.css";

// Aviso de instalación de la PWA de Montacargas: botón de instalar en
// Android/Chrome e instrucciones manuales en iOS (donde no existe
// beforeinstallprompt).
function InstallBanner() {
  const { canInstall, installed, promptInstall, showIosInstructions } = useInstallPrompt();

  if (installed) return null;

  if (canInstall) {
    return (
      <div className="mc-install">
        <span className="mc-install__text">Instala la app para usarla sin conexión.</span>
        <button type="button" className="mc-install__btn" onClick={promptInstall}>
          Instalar
        </button>
      </div>
    );
  }

  if (showIosInstructions) {
    return (
      <div className="mc-install">
        <span className="mc-install__text">
          En iPhone: toca <strong>Compartir</strong> y luego <strong>"Agregar a inicio"</strong>.
        </span>
      </div>
    );
  }

  return null;
}

export default InstallBanner;
